// GenerationTiming — Sprint 19BH Day 2 Step 2.2 · v4 manifest declarative field.
//
// v4-rewrite.md §2.3 + §6: each component declares WHEN its content is
// generated. Only `mock_exam` is `'usage'` (initial ingest skips it, user
// triggers via Mock 中心 at study time); everything else is `'initial'`
// (generated once in the autonomous ingest pass). `'either'` is reserved for
// future components that the user may toggle per-course (e.g. a future
// "interview drill" might be optional at ingest time, generated on demand
// otherwise).
//
// Why declarative (not hard-coded `if id === 'mock_exam'`):
//   The ingest workflow (Day 3 rewire) filters stages by timing via
//   MANIFEST_BY_TIMING('initial') — adding a new usage-time stage is a 1-line
//   MANIFEST edit, not a workflow code change. (Extensibility checkpoint
//   plan §12.1: target = "0 backend changes for new stage".)
import { z } from 'zod';
export const GENERATION_TIMING_VALUES = ['initial', 'usage', 'either'];
export const GenerationTimingSchema = z.enum(GENERATION_TIMING_VALUES);
//# sourceMappingURL=generation-timing.js.map